import { forwardRef } from 'react';
import type { InputHTMLAttributes, ReactNode } from 'react';
import './primitives.css';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  size?: 'sm' | 'md' | 'lg';
  leading?: ReactNode;
  trailing?: ReactNode;
  invalid?: boolean;
  fullWidth?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { size = 'md', leading, trailing, invalid, fullWidth, className, disabled, style, ...rest },
  ref,
) {
  const wrapClasses = [
    'lm-input-wrap',
    invalid ? 'lm-input-wrap--invalid' : '',
    disabled ? 'lm-input-wrap--disabled' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const inputClasses = ['lm-input', size !== 'md' ? `lm-input--${size}` : ''].filter(Boolean).join(' ');

  return (
    <span className={wrapClasses} style={fullWidth ? { width: '100%', ...style } : style}>
      {leading && <span className="lm-input-affix">{leading}</span>}
      <input ref={ref} className={inputClasses} disabled={disabled} {...rest} />
      {trailing && <span className="lm-input-affix lm-input-affix--end">{trailing}</span>}
    </span>
  );
});
